/* IMPORT */
/* HELPERS */
const stringifyNode = (node) => {
    return `${node.selector}{${node.body}${stringifyChildren(node.children)}}`;
};
const stringifyChildren = (children) => {
    let css = '';
    for (let i = 0, l = children.length; i < l; i++) {
        css += stringifyNode(children[i]);
    }
    return css;
};
/* MAIN */
const stringify = (ast) => {
    return stringifyChildren(ast.children);
};
/* EXPORT */
export default stringify;
